import styled from "styled-components"

import media from "styles/media"

interface Props {
  children: React.ReactNode
  center?: boolean | undefined
  largerMargins?: boolean | undefined
  className?: string
  setWidth?: string | undefined
  left?: boolean | undefined
  column?: boolean | undefined
  absolute?: boolean
  unset?: boolean
  flex?: boolean
}

export default function InnerWrapper({
  children,
  center = false,
  className = "",
  largerMargins = false,
  setWidth = "",
  left = false,
  column = false,
  absolute = false,
  unset = false,
  flex = false,
}: Props) {
  return (
    <Wrapper
      setWidth={setWidth}
      className={className}
      left={left}
      largerMargins={largerMargins}
      center={center}
      column={column}
      absolute={absolute}
      unset={unset}
      flex={flex}
    >
      {children}
    </Wrapper>
  )
}

const Wrapper = styled.div<{
  center?: boolean
  largerMargins?: boolean
  setWidth?: string
  left?: boolean
  column?: boolean
  absolute?: boolean
  unset?: boolean
  flex?: boolean
}>`
  width: ${({ largerMargins, setWidth }) =>
    setWidth || (largerMargins ? "68.675vw" : "86.747vw")};
  position: ${({ absolute }) => (absolute ? "absolute" : "relative")};
  z-index: 4;
  pointer-events: ${({ absolute }) => absolute && "none"};
  height: 100%;
  ${({ absolute }) => absolute && "border: 0px solid red"};

  ${({ flex }) =>
    flex &&
    `
    display: flex; 
    align-items: flex-start;
  `}

  ${({ center }) =>
    center &&
    `
    display: flex;
    justify-content: center;  
  `}
  ${({ column, center }) =>
    column && center
      ? `
    flex-direction: column;  
    align-items: center;
    justify-content: flex-start;
    `
      : column &&
        `
    flex-direction: column;  
  `}

  ${media.fullWidth} {
    width: ${({ largerMargins, setWidth }) =>
      setWidth || (largerMargins ? "1140px" : "1440px")};
    ${({ absolute }) => absolute && "left:  calc((100vw - 1440px) / 2)"};
  }
  ${media.tablet} {
    position: ${({ unset }) => unset && "unset"};
    width: ${({ largerMargins, left, setWidth }) =>
      setWidth ||
      (left ? "93.164vw" : largerMargins ? "91.797vw" : "81.445vw")};
  }
  ${media.mobile} {
    width: ${({ largerMargins, left, setWidth }) =>
      setWidth ||
      (left ? "93.164vw" : largerMargins ? "91.797vw" : "89.333vw")};
  }
`
